import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

import GraphTooltip from '~/views/dashboard/DashboardPage/components/AudiencesSection/components/GraphTooltip';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { ColumnChartBlock } from './blockTypes';

interface Props {
  block: ColumnChartBlock;
}

const SimpleColumnChart = ({ block }: Props) => {
  const data = block.data.map((d) => ({ label: d.label, value: d.value }));

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper>
        <ResponsiveBar
          data={data}
          keys={['value']}
          indexBy="label"
          margin={{ top: 20, right: 20, bottom: 50, left: 60 }}
          axisBottom={{ legend: block.xLabel, legendPosition: 'middle', legendOffset: 36 }}
          axisLeft={{ legend: block.yLabel, legendPosition: 'middle', legendOffset: -50 }}
          animate={true}
          colors={['#1784EC']}
          labelTextColor="#ffffff"
          tooltip={(data) => <GraphTooltip dataKey={data.indexValue as string} count={data.value} />}
          theme={{
            axis: {
              ticks: { text: { fontSize: 11, fill: '#6b7280' } },
              legend: { text: { fontSize: 11, fill: '#6b7280' } },
            },
            grid: { line: { stroke: '#f3f4f6' } },
          }}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleColumnChart;
